import { gql } from "@apollo/client";

export const CREATE_SALES_ARGUMENT = gql`
  mutation CreateSalesArgumentMutation($input: CreateSalesArgumentInput!) {
    createSalesArgument(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_SALES_ARGUMENT = gql`
  mutation UpdateSalesArgumentMutation($id: Int!, $input: UpdateSalesArgumentInput!) {
    updateSalesArgument(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_SALES_ARGUMENT = gql`
  mutation RemoveSalesArgumentMutation($id: Int!) {
    removeSalesArgument(id: $id) {
      ok
      error
    }
  }
`;

export const BULK_IMPORT_SALES_ARGUMENTS = gql`
  mutation BulkImportSalesArgumentsMutation($input: BulkImportSalesArgumentsInput!) {
    bulkImportSalesArguments(input: $input) {
      ok
      error
      createdCount
      skippedCount
      createdIds
    }
  }
`;

export const SALES_ARGUMENT = gql`
  query SalesArgumentQuery($id: Int!) {
    salesArgument(id: $id) {
      ok
      error
      result {
        id
        theme
        content
      }
    }
  }
`;

export const SALES_ARGUMENTS = gql`
  query SalesArgumentsQuery {
    salesArguments {
      ok
      error
      total
      results {
        id
        theme
        content
      }
    }
  }
`;
